import React, { useRef, useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const SugestoesDedicatorias = () => {
  const scrollRef = useRef(null);
  const [itemsPerPage, setItemsPerPage] = useState(6);

  const sugestoes = [
    {
      id: 'I',
      texto: 'Que esta cesta represente por si só, todo o meu amor e carinho.\nParabéns, felicidade e... bom apetite!'
    },
    {
      id: 'II',
      texto: 'Que em todos os momentos você possa ter sempre uma pitada de gostosura, surpresa e carinho!\nCom amor,'
    },
    {
      id: 'III',
      texto: 'Que o seu dia comece bem doce, saboroso e com gosto de festa.\nTe amamos muito!'
    },
    {
      id: 'IV',
      texto: 'Que este café da manhã faça o seu dia ainda mais especial.\nParabéns e mil beijos!'
    },
    {
      id: 'V',
      texto: 'Se existir algo melhor que a felicidade, é o que lhe desejamos.\nParabéns!'
    },
    {
      id: 'VI',
      texto: 'Que o abraço aqui deixado, seja sentido de forma carinhosa e como verdadeiro desejo de uma rápida recuperação.'
    },
    {
      id: 'VII',
      texto: 'Parabéns por mais esta data e que nós possamos comemorá-la para sempre!\nTe amo!'
    },
    {
      id: 'VIII',
      texto: 'Amor, que este dia seja sempre motivo de comemoração.\nCom carinho,'
    },
    {
      id: 'IX',
      texto: 'Agradeço a atenção e o carinho que recebi nestas ótimas férias que vocês me proporcionaram.\nAbraços,'
    },
    {
      id: 'X',
      texto: 'É no sorriso e paz desta criança que depositamos a esperança de um mundo melhor!\nParabéns!'
    },
    {
      id: 'XI',
      texto: 'Parabéns por essa conquista e muito sucesso na vida profissional!'
    },
    {
      id: 'XII',
      texto: 'Enquanto houver saudade, haverá amor, e onde há amor, não existe adeus!'
    }
  ];

  // Detecta o tamanho da tela para definir quantos itens mostrar por página
  useEffect(() => {
    const handleResize = () => {
      setItemsPerPage(window.innerWidth < 768 ? 1 : 6);
    };
    handleResize(); // Configura inicialmente
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Agrupa as sugestões em páginas de acordo com a tela
  const paginas = [];
  for (let i = 0; i < sugestoes.length; i += itemsPerPage) {
    paginas.push(sugestoes.slice(i, i + itemsPerPage));
  }

  const scroll = (direction) => {
    if (scrollRef.current) {
      const container = scrollRef.current;
      const pageWidth = container.clientWidth;
      const currentPage = Math.round(container.scrollLeft / pageWidth);
      const totalPages = paginas.length;

      let nextPage;
      if (direction === 'left') {
        nextPage = currentPage - 1;
        if (nextPage < 0) nextPage = totalPages - 1; // Volta para a última se estiver na primeira
      } else {
        nextPage = currentPage + 1;
        if (nextPage >= totalPages) nextPage = 0; // Volta para o início se passar da última
      }

      container.scrollTo({ left: nextPage * pageWidth, behavior: 'smooth' });
    }
  };

  return (
    <section className="py-16 bg-[#E8DCC8]" data-testid="sugestoes-dedicatorias-section">
      <style>{`.hide-scrollbar::-webkit-scrollbar { display: none; }`}</style>
      
      <div className="max-w-6xl mx-auto px-4 relative">
        <h2 
          id="sugestoes"
          className="text-3xl md:text-4xl font-bold text-[#8B4513] mb-6 text-center scroll-mt-28"
          style={{ fontFamily: 'Cormorant Garamond, serif' }}
        >
          Sugestões para Dedicatórias em Cartão
        </h2>
        <div className="w-24 h-1 bg-[#DAA520] mx-auto mb-12"></div>
        
        <div className="relative px-6 md:px-12">
          {/* Botão Voltar (Esquerda) */}
          <button 
            onClick={() => scroll('left')} 
            className="flex absolute left-0 md:-left-2 top-1/2 -translate-y-1/2 z-10 bg-[#8B4513] text-[#F5F0E6] p-1.5 md:p-2 rounded-full shadow-lg hover:bg-[#DAA520] transition-colors"
          >
            <ChevronLeft size={28} />
          </button>

          {/* Container do Carrossel */}
          <div 
            ref={scrollRef}
            className="flex overflow-x-auto pb-6 pt-2 snap-x snap-mandatory hide-scrollbar items-stretch"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {paginas.map((pagina, index) => (
              <div key={index} className="w-full shrink-0 snap-center px-1 md:px-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 h-full">
                  {pagina.map((sugestao) => (
                    <div key={sugestao.id} className="bg-[#F5F0E6] p-6 rounded-xl shadow-md border border-[#C4B8A4] flex flex-col hover:shadow-lg transition-shadow relative">
                      {/* Aspas decorativas */}
                      <div className="absolute top-2 left-4 text-6xl text-[#DAA520] opacity-20" style={{ fontFamily: 'Cormorant Garamond, serif' }}>"</div>
                      
                      <span className="text-[#DAA520] font-bold text-2xl mb-4 text-center border-b border-[#E8DCC8] pb-2 relative z-10" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Opção {sugestao.id}</span>
                      <p className="text-[#4A3728] italic whitespace-pre-line text-center leading-relaxed font-medium flex-grow relative z-10 flex items-center justify-center">
                        {sugestao.texto}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Botão Avançar (Direita) */}
          <button 
            onClick={() => scroll('right')} 
            className="flex absolute right-0 md:-right-2 top-1/2 -translate-y-1/2 z-10 bg-[#8B4513] text-[#F5F0E6] p-1.5 md:p-2 rounded-full shadow-lg hover:bg-[#DAA520] transition-colors"
          >
            <ChevronRight size={28} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default SugestoesDedicatorias;